export default function TopUtilityBar() {
  return null;
}
